module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"more":""},"en":{"more":"Show more"},"it":{"more":"Mostra di più"},"lt":{"more":""},"pl":{"more":"Pokaż więcej"},"es":{"more":"Mostrar más"}}')
  delete Component.options._Ctor
}
